// GET /api/bootstrap (architecture §7.5) under ['bootstrap']; SSE patches it (lib/sse.ts). Shared by the shell parts.
import { useQuery } from '@tanstack/react-query';
import type { BootstrapResponse } from '@hq/shared';
import { get } from './api.ts';
import { qk } from './queryKeys.ts';

export const fetchBootstrap = () => get<BootstrapResponse>('/api/bootstrap');

export function useBootstrap() {
  return useQuery({ queryKey: qk.bootstrap(), queryFn: fetchBootstrap });
}
